export default {
  dictKeys(dict) {
    let definedKeys = Object.fromEntries(Object.entries(dict).filter(([_,v]) => v != null && v !== ""))
    return Object.keys(definedKeys).filter(x => x != 'different' && x != 'value' && x != 'edited')
  },
  mergeField(dict) {
    if (typeof(dict) !== 'object') return dict;

    let keys = this.dictKeys(dict)
    let value = undefined

    if (keys.length == 0) {
      value = ""
    } else if (keys.length === 1) {
      value = dict[keys[0]]
    } else if ('value' in dict) {
      value = dict.value
    } else if ('edited' in dict) {
      value = dict.edited
    } else if ('fishbowl' in dict) {
      value = dict.fishbowl
    } else {
      console.log(keys, JSON.stringify(dict))
      value = '????'
    }
    return value;
  },
  fieldDiffers(dict, fuzzy = false) {
    if (typeof(dict) === 'undefined') return false;

    const keys = this.dictKeys(dict)
    if (keys.length === 2) {
      if ('different' in dict) {
        return dict.different
      } else if (fuzzy) {
        if (typeof (dict[keys[0]]) === 'string' && typeof (dict[keys[1]]) === 'string') {
          return dict[keys[0]].toLowerCase() !== dict[keys[1]].toLowerCase()
        } else if (typeof (dict[keys[0]]) === 'number' && typeof (dict[keys[1]]) === 'number') {
          return Math.round(dict[keys[0]]) !== Math.round(dict[keys[1]])
        }
        // eslint-disable-next-line eqeqeq
        return dict[keys[0]] != dict[keys[1]]
      } else {
        return dict[keys[0]] !== dict[keys[1]]
      }
    }
    return false
  },
  unifyTime(time) {
    switch(typeof(time)) {
      case 'number': return time;
      case 'string': return Math.round(new Date(time).getTime()/1000);
      default: return null;
    }
  }
}



// WEBPACK FOOTER //
// /src/services/orderMerge.js